function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import sendBeacon from './sendBeacon';
import getGAClientId from './getGAClientId';
import handleError from './handleError';
var GroupStatsClientType;
(function (GroupStatsClientType) {
  GroupStatsClientType[GroupStatsClientType["AGENT_ADMIN"] = 0] = "AGENT_ADMIN";
  GroupStatsClientType[GroupStatsClientType["ANDROID"] = 1] = "ANDROID";
  GroupStatsClientType[GroupStatsClientType["IPAD"] = 2] = "IPAD";
  GroupStatsClientType[GroupStatsClientType["IPHONE"] = 3] = "IPHONE";
  GroupStatsClientType[GroupStatsClientType["WEBSITE"] = 4] = "WEBSITE";
  GroupStatsClientType[GroupStatsClientType["WEBSITE_DESKTOP"] = 5] = "WEBSITE_DESKTOP";
  GroupStatsClientType[GroupStatsClientType["WEBSITE_TABLET"] = 6] = "WEBSITE_TABLET";
  GroupStatsClientType[GroupStatsClientType["WEBSITE_MOBILE"] = 7] = "WEBSITE_MOBILE";
  GroupStatsClientType[GroupStatsClientType["UNKNOWN"] = 8] = "UNKNOWN";
})(GroupStatsClientType || (GroupStatsClientType = {}));
var GroupStatsPlatform;
(function (GroupStatsPlatform) {
  GroupStatsPlatform[GroupStatsPlatform["Website"] = 0] = "Website";
  GroupStatsPlatform[GroupStatsPlatform["iPhone"] = 1] = "iPhone";
  GroupStatsPlatform[GroupStatsPlatform["iPad"] = 2] = "iPad";
  GroupStatsPlatform[GroupStatsPlatform["Android"] = 3] = "Android";
  GroupStatsPlatform[GroupStatsPlatform["Agent"] = 4] = "Agent";
  GroupStatsPlatform[GroupStatsPlatform["Admin"] = 5] = "Admin";
})(GroupStatsPlatform || (GroupStatsPlatform = {}));
const groupStatsClientTypeValues = ['AGENT_ADMIN', 'ANDROID', 'IPAD', 'IPHONE', 'WEBSITE', 'WEBSITE_DESKTOP', 'WEBSITE_TABLET', 'WEBSITE_MOBILE', 'UNKNOWN'];
const groupStatsPlatformValues = ['Website', 'iPhone', 'iPad', 'Android', 'Agent', 'Admin'];
const sendGroupStats = function sendGroupStats(data) {
  let url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/graphql';
  let immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const query = "\n    mutation SendGroupStats($input: GroupStatsStat!) {\n      postStat(groupStats: $input)\n    }\n  ";
  if (data !== null && data !== void 0 && data.clientType && !groupStatsClientTypeValues.includes(data === null || data === void 0 ? void 0 : data.clientType)) {
    handleError(new Error('trying to send an incorrect clientType value to Group Stats'));
    return false;
  }
  if (data !== null && data !== void 0 && data.platform && !groupStatsPlatformValues.includes(data === null || data === void 0 ? void 0 : data.platform)) {
    handleError(new Error('trying to send an incorrect platform value to Group Stats'));
    return false;
  }
  if (immediate) {
    let gaClientId = null;
    try {
      var _data$gaClientId;
      gaClientId = (_data$gaClientId = data.gaClientId) !== null && _data$gaClientId !== void 0 ? _data$gaClientId : window.ga.getAll()[0].get('clientId');
    } catch (err) {
      console.warn(err);
    }
    return sendBeacon(url, {
      query,
      variables: {
        input: _objectSpread(_objectSpread({}, data), {}, {
          gaClientId
        })
      }
    }, 'application/json');
  }
  return getGAClientId().then(gaClientId => sendBeacon(url, {
    query,
    variables: {
      input: _objectSpread(_objectSpread({}, data), {}, {
        gaClientId
      })
    }
  }, 'application/json')).catch(() => sendBeacon(url, {
    query,
    variables: {
      input: _objectSpread(_objectSpread({}, data), {}, {
        gaClientId: ''
      })
    }
  }, 'application/json'));
};
export default sendGroupStats;